export default __webpack_public_path__ + "static/media/01.b7d25a20.jpg";